const reducer = (state, { type, payload }) => {
	// console.log('reducer:', type, payload);
	// console.log('reducer:'+type);
	switch (type) {
		case "SET_STATE_DATA":
			return {
				...state,
				...payload,
			}
		case "LOADED":
			return {
				...state,
				message: undefined,
				loading: false
			}
		case "LOAD_FAILED":
			return {
				...state,
				message: payload,
				loading: false,
			}
		case "IN_LOADING":
			return {
				...state,
				loading: true
			}
		case "SET_PROFILE":
			let profile = state.profile || {};
			return {
				...state,
				profile: {
					...profile,
					...payload,
				}
			}
		case "SUCCESS":
			return {
				...state,
				message: payload,
				loading: false
			}


		default:
			return state
	}
}

export default reducer;